// src/pages/materials/MaterialViewer.jsx
import { useParams } from "react-router-dom";
import FormViewManager from "../../components/common/form/FormViewManager";

// Material View 컴포넌트들
import MaterialPSView from "../../components/material/MaterialPSView";
import MaterialPOView from "../../components/material/MaterialPOView";
import MaterialGRView from "../../components/material/MaterialGRView";
import MaterialGIView from "../../components/material/MaterialGIView";
import MaterialQCView from "../../components/material/MaterialQCView";
import MaterialCKView from "../../components/material/MaterialCKView";

// 🔹 doc_type 기준으로 상세 뷰 선택
function MaterialViewRouter({ data, meta, project }) {
  const VIEW_MAP = {
    PS: MaterialPSView,
    PO: MaterialPOView,
    GR: MaterialGRView,
    GI: MaterialGIView,
    QC: MaterialQCView,
    CK: MaterialCKView,
  };

  const docType = (data?.doc_type || "").toUpperCase();

  console.log("📄 MATERIAL doc_type:", docType);
  console.log("📦 MATERIAL data:", data);

  const ViewComp = VIEW_MAP[docType];

  if (!ViewComp) {
    return (
      <div className="p-6 text-red-600">
        알 수 없는 자재 문서 타입: {docType}
      </div>
    );
  }

  return <ViewComp data={data} meta={meta} project={project} />;
}

export default function MaterialViewer() {
  const { id: projectId, formId, postId } = useParams();
  const dns = formId || postId;

  console.log("🧭 MaterialViewer params:", { projectId, dns });

  return (
    <FormViewManager
      params={{
        project: projectId,
        dns,
        module: "material",
      }}
      doc_name="자재 문서"
    >
      {(props) => (
        <MaterialViewRouter
          data={props.data}
          meta={props.meta}
          project={projectId}
        />
      )}
    </FormViewManager>
  );
}
